// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7ce3863e","453":"e3933de5","455":"1103bd02"}[chunkId] + ".chunk.js";
};